import { Button, Group } from '@mantine/core';
import { IconBuildingStore, IconChecklist, IconPackage, IconSettings } from '@tabler/icons-react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuthStore } from '../stores/auth-store';

export function SupplierSectionNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const isAdmin = useAuthStore((state) => state.user?.role === 'admin');
  const links = [
    { path: '/suppliers', label: 'Suppliers', icon: IconBuildingStore, exact: true },
    { path: '/suppliers/follow-ups', label: 'Follow-ups', icon: IconChecklist },
    { path: '/suppliers/products', label: 'Products', icon: IconPackage },
    ...(isAdmin ? [{ path: '/suppliers/settings', label: 'Settings', icon: IconSettings }] : []),
  ];
  return (
    <Group gap='xs'>
      {links.map((link) => {
        const active = link.exact
          ? location.pathname === link.path
          : location.pathname.startsWith(link.path);
        return (
          <Button
            key={link.path}
            size='xs'
            variant={active ? 'filled' : 'light'}
            leftSection={<link.icon size={15} />}
            onClick={() => void navigate(link.path)}
          >
            {link.label}
          </Button>
        );
      })}
    </Group>
  );
}
